export default "/fonts/vendor/fontsource-roboto/files/roboto-vietnamese-400-normal.woff2?52cebac009baf5592e7d0ee53d8e45ed";